import { useI18n } from '@/i18n/context';
import { POWERED_BY, type PoweredByInfo } from '@/lib/brand';

/**
 * «Powered by» — سطرٌ صغير ثم اسمُ الجهة المطوِّرة نصّاً، رابطاً إلى موقعها في تبويبٍ جديد
 * (`noopener noreferrer`). **بلا شعارٍ وبلون كتابة الصفحة نفسِه** (قرار 28 سبتمبر 2026)، ويظهر في
 * الصفحة الأولى وصفحات الدخول والتسجيل وحدها — لا داخل الحسابات ولا في منصة الطفل.
 *
 * ما دام الرابطُ غائباً (`lib/brand.ts`) فالسطرُ نصٌّ محجوز بلا رابط — لا يُخترع اسمٌ ولا عنوان.
 */
export function PoweredBy({ info = POWERED_BY, className = '' }: { info?: PoweredByInfo; className?: string }) {
  const { lang } = useI18n();
  const name = (lang === 'en' ? info.nameEn ?? info.nameAr : info.nameAr ?? info.nameEn) ?? null;
  const safeUrl = info.url && /^https:\/\//.test(info.url) ? info.url : null;
  // كلمةُ الشعار الإنجليزية (قناعٌ يُلوَّن بـcurrentColor) — والاسمُ نصّاً لقارئ الشاشة وحين لا كلمةَ في الإعداد
  const mark = info.wordmark ? (
    <span className="powered-by__name powered-by__wordmark" role="img" aria-label={info.nameEn ?? name ?? ''} />
  ) : (
    <span className="powered-by__name">{name ?? 'الجهة المطوِّرة'}</span>
  );
  return (
    <div className={`powered-by ${className}`.trim()} data-testid="powered-by" data-pending={safeUrl ? undefined : 'true'}>
      <span className="powered-by__label" lang="en" dir="ltr">Powered by</span>
      {safeUrl ? (
        <a className="powered-by__link" href={safeUrl} target="_blank" rel="noopener noreferrer" aria-label={`Powered by ${name ?? ''} — يُفتح في تبويبٍ جديد`.replace('  ', ' ')}>
          {mark}
        </a>
      ) : mark}
    </div>
  );
}
